import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useGoalsConfig } from "./useGoalsConfig";

export const useUpdateGoalsConfig = () => {
  const queryClient = useQueryClient();
  const { updateMeta } = useGoalsConfig();

  return useMutation({
    mutationFn: updateMeta,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["goals"] });
    },
  });
};
